export const TOOL_IDS = {
  VINLAND_3: 'vineland_3',
  AFLS: 'afls',
  VB_MAPP: 'vb_mapp',
  PDDBI: 'pddbi',
  ABLLS_R: 'ablls_r',
  PEAK: 'peak',
  QABF: 'qabf',
  FAST: 'fast',
  SOCIALLY_SAVVY: 'socially_savvy',
  ASAP: 'asap',
  OMNIA: 'omnia',
} as const;

export const TOOL_LABELS = {
  [TOOL_IDS.VINLAND_3]: 'Vineland-3',
  [TOOL_IDS.AFLS]: 'AFLS',
  [TOOL_IDS.VB_MAPP]: 'VB-MAPP',
  [TOOL_IDS.PDDBI]: 'PDDBI',
  [TOOL_IDS.ABLLS_R]: 'ABLLS-R',
  [TOOL_IDS.PEAK]: 'PEAK',
  [TOOL_IDS.QABF]: 'QABF',
  [TOOL_IDS.FAST]: 'FAST',
  [TOOL_IDS.SOCIALLY_SAVVY]: 'Socially Savvy',
  [TOOL_IDS.ASAP]: 'ASAP',
  [TOOL_IDS.OMNIA]: 'OMNIA',
} as const;

export const TOOL_DESCRIPTIONS = {
  [TOOL_IDS.VINLAND_3]:
    "The Vineland-3 is a standardized measure of adaptive behavior--the things that people do to function in their everyday lives. Whereas ability measures focus on what the examinee can do in a testing situation, the Vineland-3 focuses on what they actually do in daily life. Because it is a norm-based instrument, the examinee's adaptive functioning is compared to that of others their age.",
  [TOOL_IDS.AFLS]:
    'The Assessment of Functional Living Skills (The AFLS) is an assessment, skill tracking system, and curriculum guide for skills that are essential for independence. The AFLS focuses on functional skills that are used in everyday for typical activities. The AFLS is composed of six unique assessment modules.',
  [TOOL_IDS.VB_MAPP]:
    'VB-MAPP is an assessment and skills-tracking system to assess the language, learning and social skills of children with autism or other developmental disabilities. A strong focus of the VB-MAPP is language and social interaction, which are the predominant areas of weakness in children with autism.',
  [TOOL_IDS.PDDBI]:
    'The PDDBI is an informant-based rating scale that is designed to assist in the assessment of children who have been diagnosed with a pervasive developmental disorder (PDD) as defined by the DSM-IV. PDD is characterised by severe and pervasive impairments in several areas of development (e.g. communication skills, reciprocal social interaction skills, presence of stereotypic behaviours/activities). Unlike existing assessments for autism/PDD, the PDDBI was developed to assess both problem behaviours as well as appropriate social, language, and learning/memory skills. It also was designed to provide age-standardised scores for both parent and teacher ratings.',
  [TOOL_IDS.ABLLS_R]:
    'This Assessment of Basic Language and Learning Skills-Revised (ABLLS-R) assessment provides a comprehensive review of 544 skills from 25 skill areas, including language, social interaction, self-help, academic and motor skills that most typically-developing children acquire prior to entering kindergarten.  The assessment results allow parents and professionals to pinpoint obstacles that have been preventing a child from acquiring new skills and to develop a comprehensive, highly personalized, language-based curriculum. It guides parents and educators in the selection of developmentally- appropriate learning objectives and allows them to track the progress in acquiring critical learner skills on the Skills Tracking Grids.',
  [TOOL_IDS.PEAK]:
    'The Promoting the Emergence of Advance Knowledge (PEAK) Comprehensive Assessment (PCA) is a standardized language and cognition assessment Developed by Dr. Mark Dixon.  The PCA consists of 344 test items across five subtests: Direct Training, Generalization, Equivalence, Transformation Expressive, and Transformation Receptive. Each section is delivered directly to the client by the administrator, and contains expressive, receptive, and motor performance items that are distributed equally across the various PCA subtests. There are four modules available in the PEAK relational training system, each one having its own specific targets.',
  [TOOL_IDS.QABF]:
    'The Questions About Behavior Functions (QABF), developed by Matson and Vollmer, is an indirect measurement tool that consists of 25 interview questions focusing on five categories of behavioral functioning: Attention, Escape, Physical, Tangible, and Nonsocial.  Each item is scored based on a four-point likert-type rating scale ranging from Never, Rarely, Some, and Often in the relation to the presentation of maladaptive behaviors. The information gathered from this indirect assessment supports the identification of the hypothesized function.',
  [TOOL_IDS.FAST]:
    'The Functional Analysis Screening Tool is an indirect functional behavior assessment tool consisting of 8 interview questions and  16 yes/no questions where information is obtained from a caregiver or an individual who knows the client well.  The information gathered from the assessment allows the behavior analyst to hypothesize the function of the client’s maladaptive behavior.',
  [TOOL_IDS.SOCIALLY_SAVVY]:
    "The Socially Savvy Checklist serves multiple purposes. The checklist assists in identifying the learner's strengths and challenges across different social skill domains. The checklist also highlights areas for which intervention is appropriate to remedy social skills deficits, allowing practitioners to prioritize the skills to the specific need of each learner.  The socially savvy manual comprises specific play-based activities that help increase critical social skills in order to allow learners to enjoy their environment in a more meaningful way",
  [TOOL_IDS.ASAP]:
    "The Empowering Autonomy: A Skills Assessment Protocol (ASAP) is an assessment protocol for skill development and tracking developed by neurodivergent (autistic/ADHD) behavior analysts. It features skills across several categories including verbal behavior, sensory, educational/vocational, interpersonal, time management, autonomy, and independent living. This assessment includes a barriers assessment to identify key areas to consider for support of skill acquisition for the learner. A social validity measure, which can be modified to the learner's language skills and preferences, is also included for the learner to self-report satisfaction with programming. In addition to tracking varied supports for the learner, there is a mediator skill grid that helps track and provide guidance for skills helpful for those serving learners who may be building targeted skills.",
  [TOOL_IDS.OMNIA]:
    'The OMNIA Assessment is an indirect behavioral assessment completed through caregiver, teacher, or stakeholder report. The assessment evaluates a broad range of skill repertoires and behavioral domains that contribute to meaningful participation in daily life and overall adaptive functioning. Assessment results may be compared to age-based norms and are intended to supplement direct assessment and clinical observation. Domains assessed may include:\n• Verbal operants and communication skills\n• Generative Language and Relational Responding\n• Executive Functioning\n• Psychological Flexibility\n• Prosocial skills and social engagement',
} as const;

export const TOOL_OPTIONS = [
  {
    id: TOOL_IDS.ABLLS_R,
    label: TOOL_LABELS[TOOL_IDS.ABLLS_R],
  },
  {
    id: TOOL_IDS.AFLS,
    label: TOOL_LABELS[TOOL_IDS.AFLS],
  },
  {
    id: TOOL_IDS.FAST,
    label: TOOL_LABELS[TOOL_IDS.FAST],
  },
  {
    id: TOOL_IDS.PDDBI,
    label: TOOL_LABELS[TOOL_IDS.PDDBI],
  },
  {
    id: TOOL_IDS.PEAK,
    label: TOOL_LABELS[TOOL_IDS.PEAK],
  },
  {
    id: TOOL_IDS.QABF,
    label: TOOL_LABELS[TOOL_IDS.QABF],
  },
  { id: TOOL_IDS.SOCIALLY_SAVVY, label: TOOL_LABELS[TOOL_IDS.SOCIALLY_SAVVY] },
  {
    id: TOOL_IDS.VB_MAPP,
    label: TOOL_LABELS[TOOL_IDS.VB_MAPP],
  },
  {
    id: TOOL_IDS.VINLAND_3,
    label: TOOL_LABELS[TOOL_IDS.VINLAND_3],
  },
  {
    id: TOOL_IDS.ASAP,
    label: TOOL_LABELS[TOOL_IDS.ASAP],
  },
  {
    id: TOOL_IDS.OMNIA,
    label: TOOL_LABELS[TOOL_IDS.OMNIA],
  },
];

export const ALWAYS_MANDATORY_TOOLS = [TOOL_IDS.QABF, TOOL_IDS.VINLAND_3];

export const SYMPTOM_OPTIONS = [
  {
    label:
      'Deficits in social-emotional reciprocity, ranging, for example, from abnormal social approach and failure of normal back- and- forth conversation; to reduced sharing of interests, emotions, or affect; to failure to initiate or respond to social interactions.',
    id: 0,
  },
  {
    label:
      'Deficits in nonverbal communicative behaviors used for social interaction, ranging, for example, from poorly integrated verbal and nonverbal communication; to abnormalities in eye contact and body language or deficits in understanding and use of gestures; to a total lack of facial expressions and nonverbal communication.',
    id: 1,
  },
  {
    label:
      'Deficits in developing, maintaining, and understanding relationships, ranging, for example, from difficulties adjusting behavior to suit various social contexts; to difficulties in sharing imaginative play or in making friends; to absences of interest in peers.',
    id: 2,
  },
  {
    label:
      'Stereotyped or repetitive motor movements, use of objects, or speech (e.g., simple motor stereotypies, lining up toys or flipping objects, echolalia, idiosyncratic phrases).',
    id: 3,
  },
  {
    label:
      'Insistence on sameness, inflexible adherence to routines, or ritualized patterns of verbal or nonverbal behavior (e.g. extreme distress at small changes, difficulties with transitions, rigid thinking patterns, greeting rituals, need to take same route or eat same food everyday).',
    id: 4,
  },
  {
    label:
      'Highly restricted, fixated interests that are abnormal in intensity or focus (e.g., strong attachment to or preoccupation with unusual objects, excessively circumscribed or preservative interest).',
    id: 5,
  },
  {
    label:
      'Hyper- or hyporeactivity to sensory input or unusual interest in sensory aspects of the environment (e.g., apparent indifference to pain/temperature, adverse response to specific sounds or textures, excessive smelling or touching of objects, visual fascination with lights or movement)',
    id: 6,
  },
] as const;

export const BARRIER_OPTIONS = [
  { id: 0, label: 'Lack of or inability to collaborate' },
  { id: 1, label: 'Patient and family schedule/ availability' },
  { id: 2, label: 'Difficulty obtaining consistent services' },
  { id: 3, label: 'Frequent cancellations' },
  { id: 4, label: 'Staff barriers' },
  { id: 5, label: 'COVID' },
  { id: 6, label: 'Medical barriers' },
  { id: 7, label: 'Lack of support' },
  { id: 8, label: 'Lack of treatment fidelity or carry-out of the treatment plan' },
  { id: 9, label: 'Cost of materials or resources' },
  { id: 10, label: 'Other' },
] as const;

export const DIAGNOSIS_REVIEWED = {
  WAS: 'was',
  WAS_NOT: 'was not',
  NONE: '',
} as const;

export const MIN_CLIENT_AGE = 6;
